import React from 'react';
import Badge from '@material-ui/core/Badge';
import ForumOutlinedIcon from '@material-ui/icons/ForumOutlined';
import { useUnreadConversations } from 'providers/SocketioProvider/chat/selectors';

const ChatNotification = () => {
  const count = useUnreadConversations([]);

  return (
    <Badge badgeContent={count} color="primary">
      <ForumOutlinedIcon />
    </Badge>
  );
};

export default React.memo(ChatNotification);
